import * as smsSendStatus from '../services/smsSendStatus';

export default {
  namespace: 'smsSendStatus',

  state: {},

  effects: {
    *getSendReport({ payload: { values } }, { call, put }) {
      const response = yield call(smsSendStatus.getSendReport, values);
      yield put({
        type: 'save',
        payload: {
          sendReportData: response?.data?.data,
          total: response?.data?.total,
        },
      });
    },
    *exportSendReport({ payload: { values }, callback }, { call }) {
      const response = yield call(smsSendStatus.exportSendReport, values);
      return callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
